import { withEnhancedGSSP } from '~/src/common/services/Networking/server/withEnhancedGSSP';
import {
  getDetailBySlug,
  getGetDetailBySlugQueryKey,
} from '~/src/queries/api-ecom/generated/api-ecom';
import ProductScreen from '~/src/screens/CatalogContent/ContentScreen/ProductScreen';
import { NextPage } from '~/src/typings/next';

const Product: NextPage = () => {
  return <ProductScreen />;
};

export const getServerSideProps = withEnhancedGSSP(async ({ query }, { prefetch, redirect }) => {
  const slug = String(query.slug);
  const pProduct = prefetch(getGetDetailBySlugQueryKey(slug), () => getDetailBySlug(slug));

  const pRedirect = pProduct.then(product => {
    if (product.slug !== slug) redirect(`/produit/${product.slug}`);
  });

  // Attente de la fin des requêtes
  await Promise.all([pProduct, pRedirect]);
});

export default Product;
